// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { chain as AlternateDC } from "@guestsupply/App/Handlers/BackOrders/SelectAltWarehouse";
import { BackOrderModel } from "@guestsupply/App/Services/BackorderManagementService";
import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { addToEndOfChain, ApiHandler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";

type HandlerType = ApiHandler<{ backorder: BackOrderModel } & HasOnSuccess & HasOnError, any>;

export const XngGaAlternateDC: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const currentBillTo = getCurrentBillToState(state).value;

    if (state.xGoogleAnalytics.includeBMAlternateDC) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const { backorder } = props.parameter;

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.BM_Alternate_DC,
            affiliation: currentBillTo?.companyName,
            brand_code: currentBillTo?.properties?.brand,
            exclusive: currentBillTo?.properties?.exclusive,
            group_descr: currentBillTo?.properties?.groupDescription,
            alt_dc: backorder?.availableAltWarehouse || backorder?.properties?.availableAltWarehouse,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

const _GaAlternateDC = XngGaAlternateDC as any;
addToEndOfChain(AlternateDC, _GaAlternateDC);
